<template>
  <div>
    <v-toolbar 
      class="secondary elevation-3"
      app 
      style="z-index: 5"
      :absolute="!$vuetify.breakpoint.mdAndDown"
      height="48"
      v-if="mostrar"
    >
      <v-toolbar-side-icon
        v-if="esAdministrador && $vuetify.breakpoint.mdAndDown"
        class="primary--text"
        @click="menu"
      />
      <img
        height="44"
        :src="logo"
        contain
        class="pointer"
        @click="$router.push({name: 'home'})"
      />
      <v-spacer/>
      <v-toolbar-items>
        <v-layout row align-center mr-2 class="mr-2 hidden-sm-and-down">
          
        </v-layout>
        <v-menu
          v-if="idiomas.length > 1"
          transition="scale-transition"
          origin="top right"
          offset-y nudge-top="-2"
          bottom left
          v-model="userLanguage"
        >
          <v-btn 
            flat
            slot="activator"
            color="primary"
            :disabled="cambiandoIdioma"
            :loading="cambiandoIdioma"
          >
            <span v-if="$vuetify.breakpoint.smAndUp" class="subheading" style="text-transform:none;">{{$t('general.idiomas.'+getIdioma)}}</span>
            <span v-if="!$vuetify.breakpoint.smAndUp" class="subheading">{{getIdioma}}</span>
            <v-icon right medium >mdi-web</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="idioma in idiomas" :key="'locale-' + idioma.value" @click="cambiarIdioma(idioma.value)">
              <v-list-tile-action>
                {{idioma.text}}
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu transition="scale-transition"
                    origin="top right" offset-y nudge-top="-2" bottom left v-model="userMenu">
          <v-btn 
            flat
            slot="activator"
            color="primary"
            :icon="!$vuetify.breakpoint.smAndUp"
          >
            <span v-if="$vuetify.breakpoint.smAndUp" class="subheading" style="text-transform:none;">{{usuario.nombre}}</span>
            <v-icon large :right="$vuetify.breakpoint.smAndUp">mdi-account-outline</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{usuario.nombre}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider/>
            <v-list-tile v-if="hayMasEntornos" @click="mostrarCambioEntornos=true">
              <v-list-tile-content>
                <v-list-tile-title>{{$t('general.misc.cambiarEntorno')}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="hayMasEntornos"/>
            <v-list-tile @click="cambiarPassword()">
              <v-list-tile-action>
                {{$t('toolbar.cambiarPassword')}}
              </v-list-tile-action>
            </v-list-tile>
            <v-divider/>
            <v-list-tile @click="doLogOut()">
              <v-list-tile-action>
                {{$t('toolbar.cerrarSesion')}}
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-fade-transition>
      <custom-dialog v-if="mostrarPopUpCambiarPassword" v-model="mostrarPopUpCambiarPassword">
        <CambiarPasswordPopUp/>
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog v-if="mostrarCambioEntornos" v-model="mostrarCambioEntornos">
        <EntornoCambiar/>
      </custom-dialog>
    </v-fade-transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EntornoCambiar from './EntornoCambiar'
import CambiarPasswordPopUp from '@/components/cambiarPassword/CambiarPasswordPopUp'

export default {
  components: {
    EntornoCambiar,
    CambiarPasswordPopUp
  },
  data () {
    return {
      userMenu: false,
      userLanguage: false,
      cambiandoIdioma: false,
      mostrarCambioEntornos: false,
      mostrarPopUpCambiarPassword: false
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: 'login/loggedIn',
      usuario: 'login/usuario',
      showDrawer: 'showDrawer'
    }),
    hayMasEntornos () {
      return this.usuario.entornos.length > 1 || this.usuario.entornos[0].idubapis.length > 1
    },
    mostrar () {
      return this.$route.name != null &&
        !this.$route.name.startsWith('incrustado.') &&
        !this.$route.name.startsWith('login')
    },
    idiomas () {
      return this.getIdiomas.map(x => {
        return {
          value: x,
          text: this.$t('general.idiomas.' + x)
        }
      }).sort((a, b) => a.text.localeCompare(b.text.localeCompare))
    }
  },
  methods: {
    ...mapActions({
      logOut: 'login/logOut',
      cambiarRol: 'login/cambiarRol',
      setShowDrawer: 'showDrawer',
      setIdioma: 'login/cambiarIdioma',
      addAlert: 'alerts/add'
    }),
    cambiarEntorno () {
      this.$router.push({name: 'home'})
    },
    async cambiarIdioma (v) {
      try {
        this.cambiandoIdioma = true
        await this.setIdioma(v)
      } catch (error) {
        console.log(error)
        this.addAlert({texto: error.message, color: 'error'})
      } finally {
        this.cambiandoIdioma = false
      }
    },
    cambiarPassword () {
      this.mostrarPopUpCambiarPassword = true
    },
    doLogOut () {
      this.userMenu = false
      this.userLanguage = false
      this.$router.push({name: 'login'})
      this.logOut()
    },
    menu () {
      this.setShowDrawer(!this.showDrawer)
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Toolbar.vue